import { buildModelManager } from "../builder.js";
const DefaultShopifyCustomerSelection = {
  __typename: true,
  id: true,
  acceptsMarketing: true,
  acceptsMarketingUpdatedAt: true,
  amountSpent: true,
  canDelete: true,
  createdAt: true,
  currency: true,
  dataSaleOptOut: true,
  defaultAddressId: true,
  displayName: true,
  email: true,
  emailMarketingConsent: true,
  firstName: true,
  hasTimelineComment: true,
  lastName: true,
  lastOrderId: true,
  lastOrderName: true,
  legacyResourceId: true,
  lifetimeDuration: true,
  locale: true,
  marketingOptInLevel: true,
  metafield: true,
  multipassIdentifier: true,
  note: true,
  numberOfOrders: true,
  ordersCount: true,
  phone: true,
  productSubscriberStatus: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyState: true,
  shopifyUpdatedAt: true,
  smsMarketingConsent: true,
  statistics: true,
  tags: true,
  taxExempt: true,
  taxExemptions: true,
  taxExemptionsBackup: true,
  totalSpent: true,
  unsubscribeUrl: true,
  updatedAt: true,
  validEmailAddress: true,
  verifiedEmail: true
};
const modelApiIdentifier = "shopifyCustomer";
const pluralModelApiIdentifier = "shopifyCustomers";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCustomerSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyCustomer does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyCustomerManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyCustomerSelection,
  operations
);
export {
  DefaultShopifyCustomerSelection,
  ShopifyCustomerManager
};
//# sourceMappingURL=ShopifyCustomer.js.map
